import { Redirect, Route, Switch } from "react-router-dom";
import { ErrorPage5 } from "./ErrorPage5";

export default function ErrorsPage() {
  return (
    <Switch>
      <Redirect from="/error" exact={true} to="/error/error-v5" />
      <Route path="/error/error-v5" component={ErrorPage5} />
    </Switch>
  );
}
